import {
    SET_DOJO_LOADING,
    SET_DOJO_ERROR,
    SET_DOJO,
  } from "../actionTypes/index";
  // import { baseUrl } from "../../apis/baseUrl";
  import { errorAlert } from "../../helpers/alerts";
  
  const setDojo = (payload) => {
    return { type: SET_DOJO, payload };
  };
  
  const setDojoError = (payload) => {
    return { type: SET_DOJO_ERROR, payload };
  };
  
  const setDojoLoading = (payload) => {
    return { type: SET_DOJO_LOADING, payload };
  };
  
  export const getAllDojo = () => {
      return async (dispatch, getState) => {
        dispatch(setDojoLoading(true));
        dispatch(setDojoError(null));
        try {
          // const { data } = await baseUrl.get("/dojo/all", 
          //     {headers: {access_token: localStorage.access_token}}
          // );
          const data = [
          {
            "id" : 1,
            "name" : "Dojo Kota Malang",
            "address" : "Aula Serbaguna Museum Brawijaya, Jl Ijen 25A, Malang",
            "isActive" : true,
            "category" : "Dojo",
            "inCharge" : null,
            "trainingTime" : "Thursday 19.00-21.00 & Sunday 07.00-08.45",
            "createdAt" : "2024-08-07T08:40:13.459Z",
            "updatedAt" : "2024-08-07T08:40:13.459Z"
          },
          {
            "id" : 2,
            "name" : "Dojo Kota Surabaya",
            "address" : "Lagoon Avenue Mall, Surabaya",
            "isActive" : true,
            "category" : "Dojo",
            "inCharge" : null,
            "trainingTime" : "Wednesday 19.00-21.00",
            "createdAt" : "2024-08-07T08:40:13.459Z",
            "updatedAt" : "2024-08-07T08:40:13.459Z"
          },
          {
            "id" : 3,
            "name" : "Dojo Kabupaten Pasuruan",
            "address" : "Green Futsal, Sangar, Pandaan, Pasuruan",
            "isActive" : true,
            "category" : "Dojo",
            "inCharge" : null,
            "trainingTime" : "Friday 19.00-21.00",
            "createdAt" : "2024-08-07T08:40:13.459Z",
            "updatedAt" : "2024-08-07T08:40:13.459Z"
          }
        ]
          dispatch(setDojo(data))
        } catch (err) {
          dispatch(setDojoError(err));
          errorAlert(err.response.data.message);
          throw new Error(err.response.data.message);
        } finally {
          dispatch(setDojoLoading(false));
        }
      };
    };
  